import React from 'react';
import GymList from '../components/gym/GymList';

/**
 * /gyms - Lista de dojos filiados (padrão).
 */
export default function GymsPage() {
    return <GymList />;
}
